import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center mb-2"
}
const _hoisted_2 = {
  key: 0,
  class: "product-filter-picker btn-group btn-group-sm w-auto me-3",
  role: "group",
  "aria-label": "Product filter type"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-12"
}
const _hoisted_5 = {
  key: 1,
  class: "col-3"
}
const _hoisted_6 = { class: "text-muted mt-3 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonProductFilterPreview = _resolveComponent("ButtonProductFilterPreview")!
  const _component_ProductFilter = _resolveComponent("ProductFilter")!
  const _component_input_select = _resolveComponent("input-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.canUseNamedProductFilter || _ctx.payload.code)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          (_ctx.canUseNamedProductFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setProductFilterType(_ctx.productFilterTypeEnum.CUSTOM))),
                  class: _normalizeClass(['btn btn-outline-primary', {'active': _ctx.isProductFilterType(_ctx.productFilterTypeEnum.CUSTOM)}]),
                  type: "button"
                }, _toDisplayString(_ctx.$t('customFilter')), 3),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setProductFilterType(_ctx.productFilterTypeEnum.NAMED))),
                  class: _normalizeClass(['btn btn-outline-primary', {'active': _ctx.isProductFilterType(_ctx.productFilterTypeEnum.NAMED)}]),
                  type: "button"
                }, _toDisplayString(_ctx.$t('existingFilter')), 3)
              ]))
            : _createCommentVNode("", true),
          (_ctx.payload.code)
            ? (_openBlock(), _createBlock(_component_ButtonProductFilterPreview, {
                key: 1,
                "product-filter-code": _ctx.payload.code
              }, null, 8, ["product-filter-code"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isProductFilterType(_ctx.productFilterTypeEnum.CUSTOM))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ProductFilter, {
              modelValue: _ctx.internalProductFilter,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalProductFilter) = $event)),
                _ctx.productFilterChanged
              ],
              errors: _ctx.errors
            }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isProductFilterType(_ctx.productFilterTypeEnum.NAMED))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_input_select, {
              modelValue: _ctx.internalPayload.code,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.internalPayload.code) = $event)),
              name: "productFilterType",
              label: _ctx.$t('existingFilter'),
              selectText: _ctx.$t('selectText'),
              options: _ctx.internalPayload.named_product_filter_options,
              rules: "required",
              errors: _ctx.errors
            }, null, 8, ["modelValue", "label", "selectText", "options", "errors"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('cachingDelayMinutes', [5])), 1)
  ], 64))
}